<template>
  <nav id="tf-menu" class="navbar navbar-default navbar-fixed-top">
    <div class="right">
      <div class="loginbtn" v-if="props.screenSize > 767" @click="login">
        {{ $t("home.login") }}
      </div>
      <div class="loginbtn" v-else @click="phone">
        <MobileOutlined style="transform: scale(1.3)" />
      </div>

      <div class="divider"></div>

      <div class="lang">
        <a-dropdown>
          <a class="ant-dropdown-link" @click.prevent>
            {{ lang }}
            <GlobalOutlined />
          </a>
          <template #overlay>
            <a-menu @click="handleMenuClick">
              <a-menu-item key="zh">
                <a>简体中文</a>
              </a-menu-item>
              <a-menu-item key="en">
                <a>English</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <!-- <div @click="goClick">点击</div> -->
      <!--       <div class="divider"></div>

      <div class="other">
        <a @click="visitor">{{ $t("home.visitor") }}</a>
      </div> -->
    </div>

    <div class="container">
      <!-- Brand and toggle get grouped for better mobile display -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#bs-example-navbar-collapse-1"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a
          class="navbar-brand"
          style="margin-right: 100px"
          v-if="props.screenSize > 1200"
          @click="home"
          >Bodor+<span v-if="props.screenSize > 767"> 3.0</span></a
        >
      </div>

      <!-- Collect the nav links, forms, and other content for toggling -->
      <div
        class="collapse navbar-collapse"
        id="bs-example-navbar-collapse-1"
        style="float: left"
      >
        <ul class="nav navbar-nav navbar-right">
          <!--           <li>
            <a href="#tf-home" class="page-scroll">{{ $t("home.home") }}</a>
          </li> -->
          <li>
            <a href="#tf-bodorplus" class="page-scroll">Bodor+</a>
          </li>
          <li>
            <a href="#tf-bodormes" class="page-scroll">BodorMES</a>
          </li>
          <li>
            <a href="#tf-bodorhub" class="page-scroll">BodorHUB</a>
          </li>
          <li>
            <a href="#tf-bodorcam" class="page-scroll">BodorCAM</a>
          </li>
          <li>
            <a href="#tf-contact" class="page-scroll">{{ $t("home.contactus") }}</a>
          </li>
          <li>
            <a @click="cam" class="page-scroll">{{ $t("home.tech") }}</a>
          </li>
          <li>
            <a @click="official" class="page-scroll">{{ $t("home.official") }}</a>
          </li>
        </ul>
      </div>
      <!-- /.navbar-collapse -->
    </div>

    <!-- /.container-fluid -->
  </nav>
</template>

<script setup>
import { onMounted, ref, inject, h } from "vue";
import { useRouter } from "vue-router";
import { GlobalOutlined, MobileOutlined } from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";
import { defineProps } from "vue";
import { Modal } from "ant-design-vue";
import axios from "axios";

const { t } = useI18n();
const props = defineProps({
  screenSize: {
    type: Number,
    default: 1920,
  },
});

const urlCommon = ref("/api/v1/chat/completions");
const token = ref(
  "Bearer fastgpt-zzj8V1B6KmAVb0GoKqCAMq9Wkq1aYxf06c5mFVETVD1g5w0yDUtYysiSoFOGZalFi"
);

const assetsUrl = require("@/assets/img/software/appicon.png");
const assetsUrl2 = require("@/assets/img/software/appicon2.png");

const i18n = useI18n();

const router = useRouter();

const lang = ref();

const reload = inject("reload");

getUrl();

const login = () => {
  router.push("/login");
};
const cam = () => {
  router.push("/visitor/software");
};
const home = () => {
  location.reload();
  router.push("/");
};
const official = () => {
  const url = "https://www.bodor.cn/";
  window.open(url, "_blank");
};
const visitor = () => {
  router.push("/visitor");
};
onMounted(() => {
  lang.value = localStorage.getItem("lang");
  if (!lang.value) {
    localStorage.setItem("lang", "zh");
    location.reload();
  }
});

async function goClick() {
  let params = {
    stream: true,
    detail: false,
    messages: [
      {
        role: "user",
        content: "功能介绍",
      },
    ],
  };
  console.log("urlCommon:", urlCommon.value);
  console.log("token:", token.value);
  console.log("params:", params);
  try {
    const response = await axios({
      url: "/v1/chat/completions",
      method: "post",
      headers: {
        Authorization: token.value,
        // 'Content-Type': 'application/json',
        "Context-type": "text/event-stream",
      },
      data: params,
      responseType: "text",
    });
    console.log("response:", response.data);
    // Node.js 环境下的流处理（浏览器环境需额外适配）
    response.data.on("data", (chunk) => {
      console.log("chunk:", chunk.toString());
      // streamData.value += chunk.toString();
    });
  } catch (err) {
    console.error("goClick error:", err);
  }
}

function getUrl() {
  let url = window.location.href;
  // 获取参数部分
  let params = url.split("?")[1];
  if (params) {
    if (params == "lan=zh") {
      lang.value = localStorage.getItem("lang");
      if (lang.value != "zh") {
        i18n.locale = "zh";
        localStorage.setItem("lang", "zh");
        lang.value = "zh";
        router.push("/");
      }
    } else if (params == "lan=en") {
      lang.value = localStorage.getItem("lang");
      if (lang.value != "en") {
        i18n.locale = "en";
        localStorage.setItem("lang", "en");
        lang.value = "en";
        router.push("/");
      }
    }
  }
}

function phone() {
  Modal.info({
    title: t("home.phone"),
    content: h("div", { class: "infoContainer" }, [
      h("p", t("home.appin2")),
      h("img", {
        src: localStorage.getItem("lang") == "zh" ? assetsUrl : assetsUrl2,
        width: "150",
        height: "150",
      }),
    ]),
    okText: t("home.appok"),
    maskClosable: true,
    onOk() {
      Modal.destroyAll();
    },
  });
}

const handleMenuClick = (e) => {
  i18n.locale = e.key;
  localStorage.setItem("lang", e.key);
  lang.value = e.key;
  location.reload();
};
</script>

<style scoped>
.right {
  position: fixed;
  line-height: 50px;
  right: 0px;
  color: white;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
}

.right > div {
  width: 100px;
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider {
  width: 1px !important;
  height: 20px !important;
  background-color: rgba(255, 255, 255, 0.3);
}

.lang a {
  color: white;
}

.lang a:hover {
  text-decoration: none;
}

.other a {
  color: white;
}

.other a:hover {
  text-decoration: none;
}

a:hover,
a:focus {
  text-decoration: none;
}

a {
  cursor: pointer;
}

@media (max-width: 991px) {
  .right {
    margin-right: 200px;
  }
}

@media (max-width: 767px) {
  .right {
    margin-right: 100px;
  }
}

@media (max-width: 550px) {
  .right {
    margin-right: 80px;
  }

  .right > div {
    width: 80px;
  }
}
</style>
